module.exports = __webpack_public_path__ + "img/azureaks.f30a4ee5.svg";